import { Component, computed, EventEmitter, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs';

import { FILE_DOCUMENT_TYPE, PermissionDirective, permissions } from '@evc/platform';
import { ButtonComponent } from '@evc/web-components';
import { I18nService, TranslatePipe } from '@shared/services/i18n/i18n.service';

import { getDataSearch } from '@app/store/selectors';
import type { FileItem } from '@app/types/file-item.type';

@Component({
  selector: 'actions-bar',
  templateUrl: './actions-bar.component.html',
  styleUrls: ['./actions-bar.component.scss'],
  imports: [
    ButtonComponent,
    PermissionDirective,
    TranslatePipe,
  ],
})
export class ActionsBarComponent {
  // TODO CLOUD-1898 - broken action (api failing)
  readonly deleteItemsPermanently = output<FileItem[]>();

  // TODO CLOUD-1899 - not implemented yet
  readonly shareItems = output<FileItem[]>();

  // TEMP - added here untill fix context menu
  readonly copyItemsTo = output<FileItem[]>();
  readonly moveItemsTo = output<FileItem[]>();
  readonly downloadItems = output<FileItem[]>();
  readonly restoreItems = output<FileItem[]>();
  readonly deleteItems = output<FileItem[]>();
  readonly clearSelection = output();

  items = input<FileItem[]>([]);
  isTrash = input(true);

  readonly #i18nService = inject(I18nService);
  readonly #store = inject(Store);
  protected PERMISSIONS = permissions;

  protected selectionLabel = computed<string>(() =>
    this.#i18nService.t('labels.nSelectedItems', { p11n: this.items().length }),
  );
  protected anyFolderSelected = computed<boolean>(() =>
    this.items().some(({ type }) => type === FILE_DOCUMENT_TYPE.FOLDER),
  );
  protected anyItemLocked = computed<boolean>(() => this.items().some(({ isLocked }) => isLocked));
  protected hasSearch = toSignal<boolean>(this.#store.pipe(select(getDataSearch), map(Boolean)));

  broadcast<T>(action: string, event: T): void {
    const emitter = this[action] as EventEmitter<T>;
    if (!emitter) throw new Error(`Unknown broadcast key: ${action}`);
    emitter.emit(event);
  }
}
